/**
 * Unified Inbox Service — Client (Packet 1 + Packet 2)
 */

import type { InboxListResult, InboxQueryParams } from '@/types/roros/inbox';
import { fetchJson, mutate } from './base-roros.service';

export const RorosInboxService = {
  list: (params?: InboxQueryParams): Promise<InboxListResult> => {
    const filtered: Record<string, string> = {};
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        if (v !== undefined && v !== null && v !== '') {
          filtered[k] = String(v);
        }
      }
    }
    const query = Object.keys(filtered).length
      ? `?${new URLSearchParams(filtered)}`
      : '';
    return fetchJson<InboxListResult>(`/api/v1/inbox${query}`);
  },

  // ─── Packet 2: per-kind action endpoints ─────────────────────────────────

  /** AC-inbox-10: QC — Approve → released, Request Changes → in_progress */
  qcTransition: (sourceId: string, payload: { toStatus: 'released' | 'in_progress'; reason?: string }) =>
    mutate(`/api/v1/control-tower/work-items/${sourceId}/transition`, 'POST', payload),

  /** AC-inbox-11: Decision approve */
  decisionApprove: (sourceId: string) =>
    mutate(`/api/v1/decisions/${sourceId}/approve`, 'POST', {}),

  /** AC-inbox-11: Decision reject (requires reason) */
  decisionReject: (sourceId: string, reason: string) =>
    mutate(`/api/v1/decisions/${sourceId}/reject`, 'POST', { reason }),

  /** AC-inbox-12: Cascade approve */
  cascadeApprove: (sourceId: string) =>
    mutate(`/api/v1/verification-inbox/${sourceId}/approve`, 'POST', {}),

  /** AC-inbox-12: Cascade reject (requires reason) */
  cascadeReject: (sourceId: string, reason: string) =>
    mutate(`/api/v1/verification-inbox/${sourceId}/reject`, 'POST', { reason }),

  /** AC-inbox-12: Cascade request ad-hoc review */
  cascadeRequestAdHoc: (sourceId: string) =>
    mutate(`/api/v1/verification-inbox/${sourceId}/request-ad-hoc-review`, 'POST', {}),
};
